import { styled } from "@mui/material";

const PREFIX = "SignIn";

// eslint-disable-next-line react-refresh/only-export-components
export const classes = {
  root: `${PREFIX}-root`,
  form: `${PREFIX}-form`,
};

export const StyledRoot = styled("div")(() => ({
  [`&.${classes.root}`]: {
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "16px",
  },

  [`& .${classes.form}`]: {
    width: "100%",
    maxWidth: 600,
  },
}));
